import BFFComingSoonPage, { getServerSideProps } from 'pages/[lang]/bff-us';

export default BFFComingSoonPage;

export { getServerSideProps };
